module.exports = __webpack_public_path__ + "static/media/BIM 360 Layout.f2cf2b81.png";